export const SCHEMA_FETCH = 'CS/SCHEMA_FETCH';
export const SCHEMA_FETCH_SUCCESS = `${SCHEMA_FETCH}_SUCCESS`;
export const SCHEMA_FETCH_ERROR = `${SCHEMA_FETCH}_ERROR`;

export const SCHEMA_SUBMIT = 'CS/SCHEMA_SUBMIT';
export const SCHEMA_SUBMIT_SUCCESS = `${SCHEMA_SUBMIT}_SUCCESS`;
export const SCHEMA_SUBMIT_ERROR = `${SCHEMA_SUBMIT}_ERROR`;

export const INSTANTIATE_SCHEMA = 'CS/INSTANTIATE_SCHEMA';

export const GO_BACK = 'CS/GO_BACK';
